<template>
  <div class="box vauto-container">
    <vauto-section-header title="VAuto Info" :collapsed="isVAutoCollapsed" v-on:collapsed-status-changed="onVAutoCollapsedStatusChanged"></vauto-section-header>
    <div class="columns is-mobile is-multiline is-left" v-if="currentRating" style="margin-top: 5px;margin-bottom: 20px !important; padding: 0;">
      <template v-if="displayMode === 'Standard'">
        <div class="column is-2">
          <div class="field">
            <label class="label">Appraised At</label>
            <div class="field">
              {{ currentRating.appraisedAt | formatDate }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">Appraised Value</label>
            <div class="field">
              {{ currentRating.appraisedValue | currency }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">Price Rank</label>
            <div class="field">
              {{ currentRating.priceRank }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">Market Days Supply</label>
            <div class="field">
              {{ new Intl.NumberFormat().format(currentRating.marketDaysSupply) }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">Like Mine</label>
            <div class="field">
              {{ new Intl.NumberFormat().format(currentRating.likeMine) }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">% Cost To Market</label>
            <div class="field">
              {{ new Intl.NumberFormat().format(currentRating.costToMarket) }}
            </div>
          </div>
        </div>
        <div class="column is-12">
          <hr class="block-hr-divider" />
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">rBook Make</label>
            <div class="field">
              {{ currentRating.rBookMake }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">rBook Model</label>
            <div class="field">
              {{ currentRating.rBookModel }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">rBook Trim</label>
            <div class="field">
              {{ currentRating.rBookTrim }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">rBook Series</label>
            <div class="field">
              {{ currentRating.rBookSeries }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">rBook Series Value</label>
            <div class="field">
              {{ new Intl.NumberFormat().format(currentRating.rBookSeriesValue) }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">rBook Avg Market Price</label>
            <div class="field">
              {{ currentRating.rBookAvgMarketPrice | currency }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">rBook Avg Odometer</label>
            <div class="field">
              {{ new Intl.NumberFormat().format(currentRating.rBookAvgOdometer) }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">rBook Odometer Adj</label>
            <div class="field">
              {{ currentRating.rBookOdometerAdj | currency }}
            </div>
          </div>
        </div>
        <div class="column is-12">
          <hr class="block-hr-divider" />
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">MMR Base</label>
            <div class="field">
              {{ currentRating.mmrBase }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">MMR Avg Odometer</label>
            <div class="field">
              {{ currentRating.mmrAvgOdometer }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">MMR Avg CR Grade</label>
            <div class="field">
              {{ currentRating.mmrAvgCrGrade }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">MMR Adj MMR</label>
            <div class="field">
              {{ currentRating.mmrAdjMmr }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">MMR Est Retail Value</label>
            <div class="field">
              {{ currentRating.mmrEstRetailValue }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">MMR Odometer</label>
            <div class="field">
              {{ currentRating.mmrOdometer }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">MMR Region</label>
            <div class="field">
              {{ currentRating.mmrRegion }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">MMR CR Grade</label>
            <div class="field">
              {{ currentRating.mmrCrGrade }}
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="field">
            <label class="label">MMR Color</label>
            <div class="field">
              {{ currentRating.mmrColor }}
            </div>
          </div>
        </div>
        <div class="column is-12">
          <hr class="block-hr-divider" />
        </div>
        <div class="column is-narrow" v-if="hasVAutoReport">
          <file-selector :usePortalViewer="false" v-model="getVAutoReport" label="Latest vAuto" :required="false" :multiple="false" :isBoxed="false" :enabled="false" displaySize="64"></file-selector>
        </div>
      </template>
      <template v-if="displayMode === 'Compact'">
        <div class="column is-4">
          <div class="field">
            <label class="label">Appraised At</label>
            <div class="field">
              {{ currentRating.appraisedAt | formatDate }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Appraised Value</label>
            <div class="field">
              {{ currentRating.appraisedValue | currency }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Price Rank</label>
            <div class="field">
              {{ currentRating.priceRank }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Market Days Supply</label>
            <div class="field">
              {{ new Intl.NumberFormat().format(currentRating.marketDaysSupply) }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Like Mine</label>
            <div class="field">
              {{ new Intl.NumberFormat().format(currentRating.likeMine) }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">% Cost To Market</label>
            <div class="field">
              {{ new Intl.NumberFormat().format(currentRating.costToMarket) }}
            </div>
          </div>
        </div>
        <div class="column is-12">
          <hr class="block-hr-divider" />
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">rBook Make</label>
            <div class="field">
              {{ currentRating.rBookMake }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">rBook Model</label>
            <div class="field">
              {{ currentRating.rBookModel }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">rBook Trim</label>
            <div class="field">
              {{ currentRating.rBookTrim }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">rBook Series</label>
            <div class="field">
              {{ currentRating.rBookSeries }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">rBook Series Value</label>
            <div class="field">
              {{ new Intl.NumberFormat().format(currentRating.rBookSeriesValue) }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">rBook Avg Market Price</label>
            <div class="field">
              {{ currentRating.rBookAvgMarketPrice | currency }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">rBook Avg Odometer</label>
            <div class="field">
              {{ new Intl.NumberFormat().format(currentRating.rBookAvgOdometer) }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">rBook Odometer Adj</label>
            <div class="field">
              {{ currentRating.rBookOdometerAdj | currency }}
            </div>
          </div>
        </div>
        <div class="column is-12">
          <hr class="block-hr-divider" />
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">MMR Base</label>
            <div class="field">
              {{ currentRating.mmrBase }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">MMR Avg Odometer</label>
            <div class="field">
              {{ currentRating.mmrAvgOdometer }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">MMR Avg CR Grade</label>
            <div class="field">
              {{ currentRating.mmrAvgCrGrade }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">MMR Adj MMR</label>
            <div class="field">
              {{ currentRating.mmrAdjMmr }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">MMR Est Retail Value</label>
            <div class="field">
              {{ currentRating.mmrEstRetailValue }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">MMR Odometer</label>
            <div class="field">
              {{ currentRating.mmrOdometer }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">MMR Region</label>
            <div class="field">
              {{ currentRating.mmrRegion }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">MMR CR Grade</label>
            <div class="field">
              {{ currentRating.mmrCrGrade }}
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">MMR Color</label>
            <div class="field">
              {{ currentRating.mmrColor }}
            </div>
          </div>
        </div>
        <div class="column is-4" v-if="currentRating && currentRating.lastCheckedAt">
          <div class="field">
            <label class="label">Last Updated</label>
            <div class="field">
              {{ currentRating.lastCheckedAt | formatDate }}
            </div>
          </div>
        </div>
        <div class="column is-12">
          <hr class="block-hr-divider" />
        </div>
        <div class="column is-narrow" v-if="hasVAutoReport">
          <file-selector :usePortalViewer="false" v-model="getVAutoReport" label="Latest vAuto" :required="false" :multiple="false" :isBoxed="false" :enabled="false" displaySize="64"></file-selector>
        </div>
        <div class="column is-4"></div>
        <div class="column is-4"></div>
      </template>
    </div>
    <div v-else-if="!currentRating">
      <div class="column is-12">
        <span class="help is-danger">
          VAuto rating information unavailable for this vehicle
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import VAutoSectionHeader from '@/components/generic/VAutoSectionHeader'
import FileSelector from '@/components/generic/FileSelector'
import utilitiesMixin from '@/mixins/generic/utilities'

export default {
  name: 'InventoryVAutoControl',
  mixins: [utilitiesMixin],
  components: {
    'vauto-section-header': VAutoSectionHeader,
    'file-selector': FileSelector
  },
  props: {
    vAutoRating: {
      type: Object,
      default: null
    },
    inventory: {
      type: Object,
      default: null
    },
    displayMode: {
      type: String,
      default: 'Standard'
    }
  },
  data () {
    return {
      currentRating: this.vAutoRating,
      isVAutoCollapsed: true
    }
  },
  computed: {
    hasVAutoReport: function () {
      if (!this.inventory || !this.inventory.attachments) {
        return false
      }
      var primaryImages = this.inventory.attachments.filter((x) => x.classType === 'Vauto')
      return primaryImages.length > 0
    },
    getVAutoReport: function () {
      if (!this.inventory || !this.inventory.attachments) {
        return []
      }
      var primaryImages = this.inventory.attachments.filter((x) => x.classType === 'Vauto')
      var result = []
      primaryImages.forEach((x) => {
        x.loaded = true
        x.imageData = x.fileLocation
        x.fileType = this.getFileType(x.fileLocation)
        result.push(x)
      })
      return result
    }
  },
  methods: {
    onVAutoCollapsedStatusChanged: function (newValue) {
      this.isVAutoCollapsed = newValue
    }
  },
  watch: {
  },
  mounted: function () {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .tolerance-error-icon {
    margin-left:5px;
  }

  .refresh-status-label {
    margin-left:1em;
  }
</style>
